import * as React from "react";
import { memo } from "react";
import "./movieItemViewStyles.css";
import { useFocusable } from "../../../utils/Helpers";
import { useTranslation } from "react-i18next";
export var SeeMoreItemView = memo(function (_a) {
    var onPress = _a.onPress, focusRaw = _a.focusRaw;
    var t = useTranslation().t;
    var ref = useFocusable({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: onPress,
    });
    return (React.createElement("div", { ref: ref, tabIndex: 0, className: "movie-card-container" },
        React.createElement("p", { className: "movie-card-btn" }, t("movie.blocks.see_more"))));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/views/movie/SeeMoreItemView.tsx
// module id = 117
// module chunks = 1